import React, { Component } from 'react';

class DayTypesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Tipos de dia </h2>
                <p>
                    Nesta página encontra todos os tipos de dia disponíveis no operador na edifício ativa na data selecionada.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar um novo tipo de dia</li>
                    <li>Pesquisar os tipos de dia disponíveis</li>
                    <li>Definir uma prioridade para os tipos de dia disponiveis </li>
                </ul>
            </div>
        );
    }
}

export default DayTypesMetadata;
